function hidePreloader() {
  var el = document.getElementById('preloader');
  if (!el) return;
  el.classList.add('preloader--hide');
  document.body.classList.add('is-loaded');
  el.addEventListener('transitionend', function () { el.remove(); }, { once:true });
  setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 1000);
}

document.addEventListener('DOMContentLoaded', hidePreloader, { once:true });

if (document.readyState !== 'loading') hidePreloader();